// extracted by mini-css-extract-plugin
module.exports = {"ForgetPassword":"ForgetPassword_ForgetPassword__1WDkF","input":"ForgetPassword_input__3cN0Q","button":"ForgetPassword_button__1rIfa","ResetPass":"ForgetPassword_ResetPass__1uxyE"};